import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-credit-note-very-briefly-credit-note',
  templateUrl: './credit-note-very-briefly-credit-note.component.html',
  styleUrl: './credit-note-very-briefly-credit-note.component.scss'
})
export class CreditNoteVeryBrieflyCreditNoteComponent {


  CreditNoteForm: any;
  reportType: any;
  advtName: any;
  issueDates: any;
  CreditNoteVBFormBeans: any = []
  CreditadvtOffVBMTotal : number = 0 ;
  CreditadvtOffVBMTotalTDS : number = 0 ;
  CreditadvtOffVBMTotalOther : number = 0 ;
   currentDate = new Date();
       constructor(
          private dialogRef: MatDialogRef<CreditNoteVeryBrieflyCreditNoteComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any,
          private service: DigisubservicesService,
          private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
        ) {
        }



        repName: any;
        startDate: any;
        endDate: any;
        offRepName: any;
        issueDates1: any;


        ngOnInit(): void {

          debugger
          let repname: any = this.data['repName'];
          
              // Then check if it's not empty and convert to array
              if (repname != "") {
                repname = repname; // This puts the single value in an array
              }
          
              this.reportType = this.data['reportType'];
              this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
              this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
              this.repName = this.data['repName'];
              this.offRepName = this.data['offRepName'];
              this.advtName = this.data['name'];
              this.issueDates = this.data.issueDates;
              this.issueDates1 = this.data['issue_date'];
    
    
  
      
  
  
  
        
          const req: any = {
            "rep_name": this.repName,
            "start_date": this.startDate,
            "end_date": this.endDate,
            "off_rep_name": this.offRepName,
            "issue_name": "",
            "issue_date": this.issueDates1,
          }

        //   this.service.getCreditNoteVB(req).subscribe((data: any) => {
        //     console.log("ADVT Data=", data);
        //     this.CreditadvtOffVBMTotal = 0;
        //     this.CreditadvtOffVBMTotalTDS = 0;
        //     this.CreditadvtOffVBMTotalOther = 0;
      
      
        //     this.CreditNoteVBFormBeans = (data as any);;
        //     for (let data of this.CreditNoteVBFormBeans) {
      
        //       this.CreditadvtOffVBMTotalTDS += parseFloat(data.tds_amt) || 0;
        //       this.CreditadvtOffVBMTotalOther += parseFloat(data.other_credit_amt) || 0;
        //       this.CreditadvtOffVBMTotal += parseFloat(data.total) || 0;
        //     }
        //   });



        this.service.getCreditNoteVB(req).subscribe((data: any) => {
  console.log("ADVT Data=", data);
  this.CreditNoteVBFormBeans = data as any;

  // Reset grand totals
  this.CreditadvtOffVBMTotal = 0;
  this.CreditadvtOffVBMTotalTDS = 0;
  this.CreditadvtOffVBMTotalOther = 0;

  // Calculate totals for each office representative and their representatives
  for (let office of this.CreditNoteVBFormBeans) {
    // Reset office rep totals
    office.tds_amt = 0;
    office.other_credit_amt = 0;
    office.total = 0;
    
    // Group representatives by rep_name
    const repMap = new Map();
    
    if (office.rep_data && office.rep_data.length > 0) {
      for (let rep of office.rep_data) {
        const repName = rep.rep_name;
        
        if (!repMap.has(repName)) {
          repMap.set(repName, {
            rep_name: repName,
            tds_amt: 0,
            other_credit_amt: 0,
            credit_amt: 0
          });
        }
        
        const groupedRep = repMap.get(repName);
        groupedRep.tds_amt += parseFloat(rep.tds_amt) || 0;
        groupedRep.other_credit_amt += parseFloat(rep.other_credit_amt) || 0;
        groupedRep.credit_amt += parseFloat(rep.credit_amt) || 0;
      }
    }
    
    // Convert map to array and store in office
    office.grouped_rep_data = Array.from(repMap.values());
    
    // Calculate office totals from grouped data
    for (let rep of office.grouped_rep_data) {
      office.tds_amt += rep.tds_amt;
      office.other_credit_amt += rep.other_credit_amt;
      office.total += rep.credit_amt;
    }
    
    // Add to grand totals
    this.CreditadvtOffVBMTotalTDS += office.tds_amt;
    this.CreditadvtOffVBMTotalOther += office.other_credit_amt;
    this.CreditadvtOffVBMTotal += office.total;
  }
});

        }

exportExcel(fileName: string): void {
  const elt = document.getElementById('print-section') as HTMLTableElement | null;
  if (!elt) {
    console.error('Element with ID "print-section" not found');
    return;
  }

  // Convert table to sheet with raw parsing to preserve formats
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(elt, { raw: true });

  // Manually convert invoice date cells (dd/mm/yyyy) into actual Excel dates
  Object.keys(ws).forEach((addr) => {
    if (!addr.startsWith('!')) {
      const cell = ws[addr];
      const v = cell.v;
      if (typeof v === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
        const [dd, mm, yyyy] = v.split('/').map(n => parseInt(n, 10));
        const date = new Date(yyyy, mm - 1, dd);
        date.setMilliseconds(0); // Prevent float rounding :contentReference[oaicite:1]{index=1}

        cell.t = 'd';
        cell.v = date;
        cell.z = 'dd/mm/yyyy';
      }
    }
  });

  // Create workbook and trigger download
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
   
// printPage(): void {
//   const printContent = document.getElementById('print-section');
//   if (!printContent) {
//     console.error('Print section not found!');
//     return;
//   }

//   const WindowPrt = window.open('', '', 'width=1200,height=800');
//   if (!WindowPrt) return;

//   WindowPrt.document.write(`
//     <html>
//       <head>
//         <title>Print Preview</title>
//         <style>
//         /* Responsive Design */
// @media print {
//     * {
//         -webkit-print-color-adjust: exact !important;
//         color-adjust: exact !important;
//         print-color-adjust: exact !important;
//     }

//     body {
//         background-color: #ffffff !important;
//         color: #2c3e50 !important;
//         font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
//     }

//     .noPrint {
//         display: none !important;
//     }

//     .container {
//         background-color: #ffffff !important;
//         box-shadow: none !important;
//         padding: 20px !important;
//     }

//     .table thead tr:first-child th {
//         background-color: #d1ecf1 !important;
//         color: #495057 !important;
//     }

//     .table thead tr:nth-child(2) th {
//         background-color: #d4edda !important;
//     }

//     .table thead tr:nth-child(3) th,
//     .table thead tr:nth-child(4) th {
//         background-color: #f8f9fa !important;
//     }

//     .table tbody tr:nth-child(even) {
//         background-color: #f8f9fa !important;
//     }

//     .table tbody tr:hover {
//         background-color: #e3f2fd !important;
//     }

//     .table tfoot td {
//         background-color: #e9ecef !important;
//         color: #495057 !important;
//     }

//     .total-row {
//         background-color: #fff3cd !important;
//     }

//     .total-row td {
//         color: #856404 !important;
//     }
// }
//         </style>
//       </head>
//       <body>
//         ${printContent.innerHTML}
//       </body>
//     </html>
//   `);

//   WindowPrt.document.close();
//   WindowPrt.focus();
//   WindowPrt.print();
//   WindowPrt.close();
// }

show = false;

    printPageA4Portrait() {
          this.show = true;
          const printSection = document.getElementById('print-section');
          if (!printSection) {
              console.error("Print section not found!");
              return;
          }
        
          const printContent = printSection.innerHTML;
        
          const screenWidth = window.screen.availWidth;
          const windowWidth = 1000;
          const leftPosition = screenWidth - windowWidth - 50;
        
          const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
        
          if (printWindow) {
              printWindow.document.open();
              printWindow.document.write(`
                  <html>
                      <head>
                          <title>Print Report</title>
                          <style>
                              @media print {
                                  @page {
                                      size: A4 portrait;
                                      margin: 5mm;
                                  }
                                  body {
                                      font-family: Arial, sans-serif;
                                      margin: 0;
                                      padding: 0;
                                      font-size: 12px !important;
                                  }
                                  .print-section {
                                      width: 100%;
                                      margin: 0 auto;
                                      padding: 0;
                                  }
                                  table {
                                      width: auto !important;
                                      border-collapse: collapse;
                                      table-layout: auto;
                                      page-break-inside: auto;
                                      border: 1px solid black !important;
                                      margin: 0 auto !important;
                                  }
                                  tr {
                                      page-break-inside: avoid;
                                      page-break-after: auto;
                                  }
                                  th, td {
                                      padding: 4px 6px !important;
                                      border: 1px solid black !important;
                                      font-size: 14px;
                                      line-height: 1.2;
                                      white-space: nowrap;
                                  }
                                  th {
                                      background-color: #f2f2f2;
                                      font-weight: bold;
                                  }
                                  tr {
                                      border-bottom: 1px solid black !important;
                                  }
                                  tr.header-row {
                                      display: table-header-group;
                                  }
                                  td[data-type="number"],
                                  td.amount,
                                  td.balance-value,
                                  td:nth-child(n+12) {
                                      text-align: right !important;
                                  }
                                  td.text,
                                  td[data-type="string"] {
                                      text-align: left !important;
                                  }
                                  .br-right { border-right: 1px solid black !important; }
                                  .br-rightt { border-right: 1px solid black !important; }
                                  .br-bottom { border-bottom: 1px solid black !important; }
                                  .br-top { border-top: 1px solid black !important; }
                                  .noPrint { display: none !important; }
                                  .footer-line {
                                      position: fixed;
                                      bottom: 0;
                                      left: 0;
                                      width: 100%;
                                      height: 1px;
                                      background-color: black;
                                  }
                                  thead { 
                                      display: table-header-group; 
                                      border: 1px solid black !important;
                                  }
                                  tfoot { 
                                      display: table-footer-group; 
                                      border: 1px solid black !important;
                                  }
                                  /* Ensure all borders are displayed */
                                  table, th, td {
                                      border-style: solid !important;
                                      border-width: 1px !important;
                                      border-color: black !important;
                                  }
                                  /* Make sure header repeats on each page */
                                  thead tr {
                                      display: table-row !important;
                                  }
                              }
                          </style>
                      </head>
                      <body>
                          <div class="print-section">
                              ${printContent}
                              <div class="footer-line"></div>
                          </div>
                          <script>
                             window.onload = function () {
                                 const table = document.querySelector('table');
                                 if (!table) {
                                     console.error("Table not found");
                                     return;
                                 }
      
                                 // Auto-size columns based on content
                                 table.style.width = 'auto';
                                 const cols = table.querySelectorAll('td, th');
                                 cols.forEach(cell => {
                                     cell.style.width = 'auto';
                                     cell.style.whiteSpace = 'nowrap';
                                 });
      
                                 let headerRowIndex = -1;
                                 const maxRowsToCheck = Math.min(10, table.rows.length);
      
                                 // Find header row with column names
                                 for (let i = 0; i < maxRowsToCheck; i++) {
                                     const row = table.rows[i];
                                     const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
      
                                     if (row.cells.length >= 8 &&
                                         (cellTexts.includes('Invoice No') ||
                                          cellTexts.includes('Receipt No') ||
                                          cellTexts.includes('Balance'))) {
                                         headerRowIndex = i;
                                         break;
                                     }
                                 }
      
                                 if (headerRowIndex >= 0) {
                                     // Create thead and move only the actual header row into it
                                     let thead = table.querySelector('thead');
                                     if (!thead) {
                                         thead = document.createElement('thead');
                                         table.insertBefore(thead, table.firstChild);
                                     }
      
                                     const headerRow = table.rows[headerRowIndex];
                                     thead.appendChild(headerRow.cloneNode(true));
                                 }
      
                                 // Alignment processing
                                 const cells = document.querySelectorAll('td');
                                 cells.forEach(cell => {
                                     const content = cell.textContent.trim();
      
                                     if (content.includes('येणे') ||
                                         content.includes('Opening Balance') ||
                                         content.match(/^\\d+\\s+येणे$/) ||
                                         content.includes('Balance C/F') ||
                                         content.includes('Total')) {
                                         cell.style.textAlign = 'right';
                                         cell.classList.add('balance-value');
                                     }
      
                                     const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                     if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                         cell.style.textAlign = 'right';
                                         cell.classList.add('amount');
                                     }
      
                                     cell.style.border = '1px solid black';
                                 });
      
                                 setTimeout(() => {
                                     window.print();
                                     setTimeout(() => { window.close(); }, 500);
                                 }, 200);
                             };
                          </script>
                      </body>
                  </html>
              `);
              printWindow.document.close();
          } else {
              console.error("Failed to open print window.");
          }
      }





}
